import { render, staticRenderFns } from "./CreateTag.ts.vue?vue&type=template&id=03230d4c"
import script from "./CreateTag.ts.vue?vue&type=script&lang=ts"
export * from "./CreateTag.ts.vue?vue&type=script&lang=ts"
import style0 from "./CreateTag.ts.vue?vue&type=style&index=0&id=03230d4c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports